import { render, staticRenderFns } from "./LvScrollableBlock.vue?vue&type=template&id=ef8bb006"
import script from "./LvScrollableBlock.vue?vue&type=script&lang=js"
export * from "./LvScrollableBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports